import React from 'react';
import { Button, Modal } from '@getro/rombo';
import { Flex, Text } from 'rebass/styled-components';
import PropTypes from 'prop-types';

import { NoteForm } from '../noteForm';
import { NoteContent } from './NoteContent';
import { NoteMenu } from './menu';
import { useNote } from './useNote';

export const Note = ({ queryParams, note, type, contactId }) => {
  const {
    isEditing,
    setIsEditing,
    showDeleteConfirmation,
    setShowDeleteConfirmation,
    isLoadingUpdateNote,
    isLoadingDeleteNote,
    onEdit,
    onSave,
    onShowDeleteConfirmation,
    onDelete,
  } = useNote({ queryParams, contactId, note });

  return isEditing ? (
    <NoteForm note={note} onSuccess={onSave} onClose={() => setIsEditing(false)} isLoading={isLoadingUpdateNote} />
  ) : (
    <>
      <NoteContent
        key={note.id}
        note={note}
        type={type}
        headerEnd={type !== 'public' ? <NoteMenu onEdit={onEdit} onDelete={onShowDeleteConfirmation} /> : null}
      />
      {showDeleteConfirmation && (
        <Modal
          title="Delete note?"
          actions={
            <Flex justifyContent="flex-end" sx={{ columnGap: '8px' }}>
              <Button variant="secondary" onClick={() => setShowDeleteConfirmation(false)}>
                Cancel
              </Button>
              <Button variant="danger" loading={isLoadingDeleteNote} onClick={onDelete}>
                Delete note
              </Button>
            </Flex>
          }
          onCancel={() => setShowDeleteConfirmation(false)}
        >
          <Text fontSize="14px">The note will be deleted for every user.</Text>
        </Modal>
      )}
    </>
  );
};

Note.propTypes = {
  queryParams: PropTypes.object,
  note: PropTypes.object,
  type: PropTypes.oneOf(['default', 'read', 'matches', 'public']),
  contactId: PropTypes.number.isRequired,
};

Note.defaultProps = {
  queryParams: {},
  note: {},
  type: 'default',
};
